import { useQuery } from '@tanstack/react-query';
import { edgeAccountDigestsApi } from '../api/services';

/**
 * The global digest settings (sc-6504). One cache entry shared by the settings
 * dialog and the location digest-preference switches, so a dialog save
 * (setQueryData on this key) updates the switches without a refetch.
 */
export const DIGEST_SETTINGS_QUERY_KEY = ['edge-account-digests', 'settings'] as const;

export function useDigestSettings({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: DIGEST_SETTINGS_QUERY_KEY,
    queryFn: () => edgeAccountDigestsApi.settings.get(),
    enabled,
  });
}
